import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import { addAudit } from "../audits/addAudits";
import { CardContent, Button, CircleProgress } from "reactackle";
import { isMobile } from "react-device-detect";
import checkBeforeSave from "../../checkBeforeSave/checkBeforeSave";
import getInputField from "../customFields/getInputField";
import {
  actionAddArray2Redux,
  selectARecord,
  notifyUsers,
  setUiFlag
} from "../../../../store/actions";
import moment from "moment";
import terms from "./terms";
import numeral from "numeral";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { TextField } from "reactackle";
import { backupImage } from "../ContentGrid/backupImage";

class OrderPadDirectSupplier extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        ...this.props.selectedRecord
      },
      userEmail:
        this.props.userProfile && this.props.userProfile.userEmail
          ? this.props.userProfile.userEmail
          : ""
    },
    showForm: true,
    allowedFields: [
      "mobile",
      "name",
      "address",
      "specialInstructions",
      "requestedItems"
    ],
    stage: "orderForm"
  };

  componentDidMount() {
    let todaysDate = moment()
      .format("DD-MM-YYYY")
      .toString();
    let targetDate = todaysDate;
    let targetDeliveryDate = moment()
      .add(1, "day")
      .format("ddd DD-MM-YYYY")
      .toString();
    let tgtOrder = {
      name: "",
      address: ""
    };
    this.props.onSetUiFlag("orderStage", "showForm");
    if (this.props.createNewRec) {
      if (this.props.orders && this.props.orders.length > 0) {
        let myOrders = this.props.orders.filter(singOrder => {
          //console.log(singOrder.mobile + " vs " + this.props.cellPhone);
          return singOrder.mobile === this.props.cellPhone;
        });
        if (myOrders && myOrders.length > 0) {
          //console.log(JSON.stringify(myOrders));
          tgtOrder = myOrders[myOrders.length - 1];

          this.setState(prevState => {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  name: tgtOrder.name,
                  address: tgtOrder.address,
                  deliveryDate: targetDate,
                  targetDeliveryDate: targetDeliveryDate
                }
              },
              tgtOrder: tgtOrder
            };
          });
        }
      } else {
        this.setState(prevState => {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                deliveryDate: targetDate,
                targetDeliveryDate: targetDeliveryDate
              }
            },
            tgtOrder: tgtOrder
          };
        });
        //console.log("orders not found");
      }
    } else {
      //console.log("its not even a new rec" + this.props.operationType);
    }
    if (!this.props.cellPhone || this.props.cellPhone === "") {
      const cellPhone = prompt("Please enter your cell phone to continue");

      if (cellPhone && cellPhone !== undefined && cellPhone !== "") {
        this.props.onSetUiFlag("cellPhone", cellPhone);
        //console.log("allOrders length: " + JSON.stringify(this.props.db));

        this.setState(prevState => {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                mobile: cellPhone,
                deliveryDate: targetDate
              }
            },
            proceedForward: true
          };
        });
      } else {
        this.setState(prevState => {
          return {
            ...prevState,
            cellPhone: cellPhone,
            proceedForward: false
          };
        });
      }
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          data: {
            ...prevState.data,
            payload: {
              ...prevState.data.payload,
              mobile: this.props.cellPhone,
              deliveryDate: targetDate,
              requestedItems: ""
            }
          },
          proceedForward: true
        };
      });
    }
  }

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        () => {
          this.procCalcFields(id);
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        () => {
          this.procCalcFields(id);
        }
      );
    }
  };

  procCalcFields = id => {
    //console.log("Checking ID: " + id);
    let allFields = this.props.ogTableDef[this.props.path];
    for (let key in allFields) {
      let fldDef = allFields[key];
      if (fldDef.type === "calculation" && id === fldDef.triggerField) {
        //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
        if (fldDef.calcType === "subFieldsSum") {
          if (fldDef.subFieldOperation === "SUM") {
            this.getSubGridSum(
              fldDef.name,
              fldDef.subGridName,
              fldDef.subGridField
            );
          } else {
          }
        } else if (fldDef.calcType === "mainFieldCalc") {
          this.getCalcdField(fldDef.name, fldDef.formula);
        }
      }
    }
  };

  getValue = (stateVal, operand) => {
    let res = 0.0;
    if (stateVal !== undefined) {
      if (!isNaN(stateVal)) {
        res = parseFloat(stateVal);
      }
    } else {
      if (!isNaN(operand)) {
        res = parseFloat(operand);
      }
    }
    return res;
  };

  getCalcdField = (calcFieldName, calcRules) => {
    //console.log(calcFieldName + " " + JSON.stringify(calcRules));
    let result = 0.0;

    //currently only one rule will work
    let currRule = calcRules[0];
    if (currRule && currRule !== undefined) {
      let val1 = this.getValue(
        this.state.data.payload[currRule.operand1],
        currRule.operand1
      );
      let val2 = this.getValue(
        this.state.data.payload[currRule.operand2],
        currRule.operand2
      );
      let op = currRule.operation;
      if (op && !isNaN(val1) && !isNaN(val2)) {
        if (op === "+") {
          result = val1 + val2;
        } else if (op === "-") {
          result = val1 - val2;
        } else if (op === "*") {
          result = val1 * val2;
        } else if (op === "/") {
          result = val1 / val2;
        }
      }
      // console.log(
      //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
      // );
      if (result !== undefined && !isNaN(result)) {
        this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
      }
    }
  };

  getSubGridSum = (calcFieldName, subGridName, subFieldToProcess) => {
    let items = this.state.data.payload[subGridName];

    if (items && items !== undefined && items.length > 0) {
      let invSum = items.reduce((sum, obj) => {
        //console.log(obj[subFieldToProcess]);
        if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
          return sum + parseFloat(obj[subFieldToProcess]);
        } else {
          return sum;
        }
      }, 0);
      invSum = invSum.toFixed(2);
      this.stateChangeHandler(invSum, calcFieldName, true);
    }
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      this.props.path,
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef,
      this.props.db
    );
  };

  getFields = () => {
    if (this.props.ogTableDef[this.props.path]) {
      return Object.keys(this.props.ogTableDef[this.props.path]).map(fldKey => {
        if (this.state.allowedFields.includes(fldKey)) {
          return this.getField(fldKey);
        }
      });
    } else {
      console.log("chacha some problems");
    }
  };

  getTotal = currBucket => {
    //console.log("calcing total again: " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      try {
        let totAmt = currBucket.reduce((sum, item) => {
          sum = sum + parseFloat(item.amount.replace(/,/g, ""));
          return parseFloat(sum);
        }, 0);

        return totAmt.toFixed(2);
      } catch (err) {
        return 0;
      }
    }
  };

  saveHandler = isCancellation => {
    this.stateChangeHandler(
      this.getTotal(this.state.data.payload.requestedItems, "orderTotal", true)
    );
    if (
      this.state.data.payload.name === "" ||
      this.state.data.payload.name === undefined ||
      this.state.data.payload.address === undefined ||
      this.state.data.payload.address === ""
    ) {
      alert("Please enter both Name and Address before placing the order.");
      return "";
    }
    if (this.props.db["bucket"] && this.props.db["bucket"].length > 0) {
      this.stateChangeHandler(this.props.cellPhone, "author", true);
      this.stateChangeHandler([], "supplierPrices", true);
      if (isCancellation) {
        this.stateChangeHandler("CANCELLED", "status", true);
      } else {
        this.stateChangeHandler("WITH GROCER FOR PRICE", "status", true);
      }

      let oItems = _.cloneDeep(this.props.db["bucket"]);
      this.stateChangeHandler(oItems, "requestedItems", true);
      let prod1 = this.props.db["bucket"][0];

      // rec.status = "PICKED BY SUPPLIER";
      //   rec.supplierContactName = supplierContactName;
      //   rec.supplierCellPhone = supplierCellPhone;

      this.stateChangeHandler(prod1.productSupplier, "supplier", true);
      this.stateChangeHandler(
        prod1.supplierContactName,
        "supplierContactName",
        true
      );
      this.stateChangeHandler(
        prod1.supplierContactPhone,
        "supplierCellPhone",
        true
      );

      let todaysTime = moment()
        .format("h:mm a")
        .toString();

      let todaysDate = moment()
        .format("DD-MM-YYYY")
        .toString();

      let cloudPath = this.props.path;

      if (
        this.state.data.payload &&
        this.state.data.payload.key &&
        this.state.data.payload.key !== ""
      ) {
        cloudPath = this.props.path + "/" + this.state.data.payload.key;
        Promise.all([
          addAudit(
            this.stateChangeHandler,
            this.props.firebase.auth.currentUser.phoneNumber,
            false
          )
        ]).then(res => {
          this.props.firebase.db
            .ref("/" + cloudPath)
            .once("value")
            .then(snap => {
              return snap.ref.set(this.state.data.payload);
            })
            .catch(err => {
              console.log(err);
              return console.log("some error: " + err);
            })
            .then(err => {
              //clear the bucket
              this.props.firebase.db
                .ref(
                  "/myOrders" +
                    "/" +
                    this.props.cellPhone +
                    "/" +
                    this.state.data.payload.key
                )
                .once("value")
                .then(snap => {
                  return snap.ref.set(this.state.data.payload);
                })
                .catch(err => {
                  console.log(err);
                  return console.log("some error: " + err);
                })
                .then(err => {
                  console.log("Updated: " + err);
                });
              this.props.onAddArray({
                path: "bucket",
                payload: []
              });
              //sending notifications
              let phArray = [];
              phArray.push(this.state.data.payload.mobile);
              if (isCancellation) {
                this.props.onNotifyUsers(
                  "Your order has been cancelled. We would love to see you again. Please Kabir Hossain at 94562455 if you cancelled order due to any problems.",
                  phArray
                );
              } else {
                this.stateChangeHandler(
                  "showUpdateConfirmation",
                  "stage",
                  false
                );
                this.props.onSetUiFlag("orderStage", "showUpdateConfirmation");

                let userNotifyText =
                  "Your order has been updated, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.";

                this.props.onNotifyUsers(userNotifyText, phArray);

                let totAmt = this.state.data.payload.requestedItems.reduce(
                  (sum, item) => {
                    sum = sum + parseFloat(item.amount.replace(/,/g, ""));
                    return parseFloat(sum);
                  },
                  0
                );

                totAmt = totAmt.toFixed(2);

                let suppNotifyText =
                  this.state.data.payload.name +
                  " " +
                  this.state.data.payload.mobile +
                  " updated $" +
                  totAmt +
                  " " +
                  this.state.data.payload.targetDeliveryDate;

                this.props.onNotifyUsers(
                  suppNotifyText,
                  this.getAllSuppliers()
                );
              }
            });
        });
      } else {
        Promise.all([
          addAudit(
            this.stateChangeHandler,
            this.props.firebase.auth.currentUser.phoneNumber,
            true
          )
          //get new ID
        ]).then(res => {
          this.stateChangeHandler(todaysTime, "orderTime", true);
          this.stateChangeHandler(todaysDate, "deliveryDate", true);
          var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
          newInv
            .set(this.state.data.payload)
            .catch(err => {
              console.log(err);
              return console.log("some error: " + err);
            })
            .then(err => {
              //clear the bucket
              this.props.firebase.db
                .ref(
                  "/myOrders" + "/" + this.props.cellPhone + "/" + newInv.key
                )
                .once("value")
                .then(snap => {
                  return snap.ref.set(this.state.data.payload);
                })
                .catch(err => {
                  console.log(err);
                  return console.log("some error: " + err);
                })
                .then(err => {
                  console.log("updated");
                });
              this.props.onAddArray({
                path: "bucket",
                payload: []
              });
              //sending notifications
              this.stateChangeHandler("showConfirmation", "stage", false);
              this.props.onSetUiFlag("orderStage", "showConfirmation");
              let phArray = [];
              phArray.push(this.state.data.payload.mobile);
              this.props.onNotifyUsers(
                "Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.",
                phArray
              );
              let totAmt = this.state.data.payload.requestedItems.reduce(
                (sum, item) => {
                  let thisAmt = parseFloat(item.amount.replace(/,/g, ""));
                  if (thisAmt === "NaN") {
                    thisAmt = 0;
                  }
                  sum = sum + thisAmt;
                  return parseFloat(sum);
                },
                0
              );
              totAmt = totAmt.toFixed(2);
              console.log("totAmt: " + totAmt);
              this.props.onNotifyUsers(
                this.state.data.payload.name +
                  " " +
                  this.state.data.payload.mobile +
                  " $" +
                  totAmt +
                  " " +
                  this.state.data.payload.targetDeliveryDate,
                this.getAllSuppliers()
              );
            });
        });
      }
    } else {
      console.log("no items");
    }
  };

  getAllSuppliers = () => {
    let allSup = _.chain(this.props.users)
      .filter(item => item.roleName === "STOREADMIN")
      .pluck("userMobile")
      .filter(item => item !== "" && item !== null && typeof item === "string")
      .value();
    return allSup;
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress indeterminate subtitle="Saving..." />
      </CardContent>
    );
  };

  /*
-webkit-tap-highlight-color: rgba(0,0,0,0);
font-size: 14px;
line-height: 1.42857143;
color: #333;
box-sizing: border-box;
font-family: "RobotMedium";
position: fixed;
top: 60px;
width: 95%;
align-self: center;
z-index: 99999;


-webkit-tap-highlight-color: rgba(0,0,0,0);
font-size: 14px;
line-height: 1.42857143;
color: #333;
box-sizing: border-box;
font-family: "RobotMedium";
z-index: -1;
margin-top: 60px;


  */

  getTopHeader = () => {
    return (
      <table
        className={
          isMobile
            ? "table table-striped table-bordered table-sm"
            : "table table-striped table-bordered table-lg"
        }
      >
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              <Button
                text="SUBMIT ORDER"
                onPress={() => this.saveHandler()} //this.getAllSuppliers()}
                colorScheme="primary"
                disabled={
                  !this.state.showForm ||
                  checkBeforeSave(
                    this.props.path,
                    this.state.data.payload,
                    this.props.ogTableDef
                  )
                }
              />
            </td>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              <Button
                text="BACK TO SHOP"
                onPress={() =>
                  this.props.backToList(
                    "shopFromASupplier",
                    "supplierShopItems"
                  )
                }
                colorScheme="primary"
                disabled={!this.state.showForm}
              />
            </td>
          </tr>
          <tr>
            {this.props.operationType !== "add" && (
              <td
                style={{
                  textAlign: "center",
                  padding: "5px"
                }}
                colSpan={2}
              >
                <Button
                  text="CANCEL THIS ORDER"
                  onPress={e => {
                    if (
                      this.state.data.payload.key &&
                      this.state.data.payload.key !== ""
                    ) {
                      window.confirm(
                        "Are you sure you wish to cancel this order?"
                      ) && this.cancelOder();
                    }
                  }}
                  colorScheme="warning"
                  disabled={!this.state.showForm}
                />
              </td>
            )}
          </tr>
        </tbody>
      </table>
    );
  };

  cancelOder = () => {
    this.saveHandler(true);
    this.stateChangeHandler("showCancellation", "stage", false);
    this.props.onSetUiFlag("orderStage", "showCancellation");
  };

  //f2f4f6

  getOrderForm = () => {
    return (
      <div
        style={{
          WebkitOverflowScrolling: "auto",
          height: "100%"
        }}
      >
        <div style={{ paddingTop: "5px" }}>
          <div
            style={{
              margin: "5px"
            }}
          >
            {this.state.showForm && this.state.proceedForward && (
              <div
                style={{
                  padding: "1px",
                  textAlign: "right",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "white",
                  zIndex: "-9"
                }}
              >
                <TextField
                  value={this.state.data.payload["name"]}
                  onChange={e => {
                    this.stateChangeHandler(e.value, "name", true);
                  }}
                  fullWidth
                  placeholder="ENTER YOUR NAME"
                />
              </div>
            )}

            {this.state.showForm && this.state.proceedForward && (
              <div
                style={{
                  padding: "1px",
                  textAlign: "right",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "white",
                  zIndex: "-9"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    direction: "row",
                    alignItems: "center"
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      border: "0px solid black",
                      cursor: "pointer",
                      width: "200px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "left",
                      margin: "5px",
                      marginLeft: "15px",
                      marginRight: "15px"
                    }}
                    onClick={() => {}}
                  >
                    Delivery Date
                  </div>
                  <div
                    style={{
                      borderRadius: "5px",
                      color: "#fff",
                      backgroundColor: "rgb(30, 101, 144)",
                      fontSize: "1.5em",
                      border: "0px solid black",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "60px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "center",
                      margin: "5px",
                      marginLeft: "15px"
                    }}
                    onClick={() => {
                      let currTgtDate = moment(
                        this.state.data.payload.targetDeliveryDate,
                        "ddd DD-MM-YYYY"
                      );
                      let newDate = currTgtDate.subtract(1, "day");
                      let minDate = moment();
                      if (newDate.isAfter(minDate)) {
                        this.stateChangeHandler(
                          newDate.format("ddd DD-MM-YYYY").toString(),
                          "targetDeliveryDate",
                          true
                        );
                      } else {
                        this.stateChangeHandler(
                          minDate
                            .add(1, "day")
                            .format("ddd DD-MM-YYYY")
                            .toString(),
                          "targetDeliveryDate",
                          true
                        );
                      }
                    }}
                  >
                    {"<"}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      lineHeight: "45px",
                      textAlign: "center"
                    }}
                  >
                    {this.state.data.payload["targetDeliveryDate"]}
                  </div>
                  <div
                    style={{
                      borderRadius: "5px",
                      color: "#fff",
                      backgroundColor: "rgb(30, 101, 144)",
                      fontSize: "1.5em",
                      border: "0px solid black",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "60px",
                      height: "30px",
                      lineHeight: "30px",
                      textAlign: "center",
                      margin: "5px",
                      marginRight: "15px"
                    }}
                    onClick={() => {
                      let currTgtDate = moment(
                        this.state.data.payload.targetDeliveryDate,
                        "ddd DD-MM-YYYY"
                      );
                      let newDate = currTgtDate.add(1, "day");
                      let minDate = moment();
                      if (newDate.isAfter(minDate)) {
                        this.stateChangeHandler(
                          newDate.format("ddd DD-MM-YYYY").toString(),
                          "targetDeliveryDate",
                          true
                        );
                      } else {
                        this.stateChangeHandler(
                          minDate
                            .add(1, "day")
                            .format("ddd DD-MM-YYYY")
                            .toString(),
                          "targetDeliveryDate",
                          true
                        );
                      }
                    }}
                  >
                    {">"}
                  </div>
                </div>
              </div>
            )}

            {this.state.showForm && this.state.proceedForward && (
              <div
                style={{
                  padding: "1px",
                  textAlign: "right",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "white",
                  zIndex: "-9"
                }}
              >
                <TextField
                  value={this.state.data.payload["otherItems"]}
                  onChange={e => {
                    this.stateChangeHandler(e.value, "otherItems", true);
                  }}
                  fullWidth
                  placeholder={
                    "Special Insructions or any items not found you can add here. \nএপ্সের বাইরে কোন অর্ডার থাকলে এই বক্সে লিখুনI আইটেম, ওজন এবং পরিমান লিখতে ভুলবেন না"
                  }
                  multiline
                  multilineRows={{ min: 3 }}
                />
              </div>
            )}

            {this.state.showForm && this.state.proceedForward && (
              <div
                style={{
                  padding: "1px",
                  textAlign: "right",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "white",
                  zIndex: "-9"
                }}
              >
                <TextField
                  value={this.state.data.payload["address"]}
                  onChange={e => {
                    this.stateChangeHandler(e.value, "address", true);
                  }}
                  fullWidth
                  placeholder="ENTER YOUR ADDRESS"
                  multiline
                  multilineRows={{ min: 3 }}
                />
              </div>
            )}
            <div
              style={{
                height: "45px",
                margin: "5px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  padding: "0.5em 0.5em",
                  borderRadius: "8px",
                  color: "#fff",
                  backgroundColor: "rgb(30, 101, 144)",
                  border: "0px",
                  cursor: "pointer",
                  marginLef: "5px",
                  fontWeight: "bold",
                  maxWidth: "200px",
                  marginLeft: "10px",
                  marginTop: "5px"
                }}
                onClick={this.props.addMoreItems}
              >
                <span>
                  <icon
                    className="fa fa-shopping-bag"
                    style={{
                      color: "white",
                      marginRight: "15px",
                      fontSize: "18px"
                    }}
                  />
                </span>
                ADD MORE ITEMS
              </div>
              <div
                style={{
                  padding: "0.5em 0.5em",
                  borderRadius: "8px",
                  color: "#fff",
                  backgroundColor: "red",
                  border: "0px",
                  cursor: "pointer",
                  marginLef: "5px",
                  fontWeight: "bold",
                  maxWidth: "200px",
                  marginLeft: "10px",
                  marginTop: "5px"
                }}
                onClick={() => {
                  this.props.onAddArray({ path: "bucket", payload: [] });
                }}
              >
                <span>
                  <icon
                    className="fa fa-trash"
                    style={{
                      color: "white",
                      marginRight: "15px",
                      fontSize: "18px"
                    }}
                  />
                </span>
                REMOVE ALL ITEMS
              </div>
            </div>
            {this.state.showForm &&
              this.state.proceedForward &&
              this.getPadItems()}

            {!this.state.proceedForward && (
              <h1>YOUR CELL NUMBER IS REQUIRED TO PROCEED</h1>
            )}
            {!this.state.showForm && this.getLoader()}
          </div>

          {/* {!isMobile && (
              <div>
                <Card>
                  <CardAreaMain>
                    <CardContent style={{ pading: "0px" }}>
                      <div style={{ fontSize: "15px", color: "grey" }}>
                        Carefully complete below fields and tap on SUBMIT
                        button. Fields marked with * are compulsory.
                      </div>
                      {this.state.showForm &&
                        this.state.proceedForward &&
                        this.getFields()}
                      {!this.state.showForm && this.getLoader()}
                    </CardContent>
                  </CardAreaMain>
                </Card>
              </div>
            )} */}
        </div>
      </div>
    );
  };

  getOrderConformation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "12px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "70px"
        }}
      >
        <div
          style={{
            margin: "auto",
            border: "5px solid green",
            width: "100px",
            height: "100px",
            borderRadius: "100px",
            lineHeight: "90px",
            verticalAlign: "middle"
          }}
        >
          <icon
            className="fa fa-check fa-3x"
            style={{
              color: "green",
              verticalAlign: "middle"
            }}
          />
        </div>
        <div
          style={{
            marginTop: "12px",
            marginBottom: "12px"
          }}
        >
          Your order is successfuly submitted
        </div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          {terms()}
        </div>
      </div>
    );
  };

  getOrderUpdateConfirmation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "12px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        <div
          style={{
            margin: "auto",
            border: "5px solid green",
            width: "100px",
            height: "100px",
            borderRadius: "100px",
            lineHeight: "90px",
            verticalAlign: "middle"
          }}
        >
          <icon
            className="fa fa-check fa-3x"
            style={{
              color: "green",
              verticalAlign: "middle"
            }}
          />
        </div>
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px"
          }}
        >
          Your order has been updated
        </div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          {terms()}
        </div>
      </div>
    );
  };

  getOrderCancellation = () => {
    window.scroll(0, 0);
    return (
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        <div>You order has been CANCELLED</div>
        <div
          style={{
            marginTop: "10px"
          }}
        >
          <Button
            text="VIEW YOUR ORDERS"
            onPress={() =>
              this.props.backToList("orderlist", "deliveryRequest")
            }
            colorScheme="primary"
            disabled={!this.state.showForm}
          />
        </div>
      </div>
    );
  };

  getItems = () => {
    let currBucket = _.cloneDeep(this.props.db["bucket"]);
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket[0].key !== undefined
    ) {
      return currBucket.map(product => {
        return (
          <div
            style={{
              border: "1px solid white",
              margin: "1px",
              padding: "0px",
              marginBottom: "5px"
            }}
          >
            <div
              style={{
                display: "flex"
              }}
            >
              <div>
                <div
                  style={{
                    borderRadius: "30px",
                    color: "#fff",
                    backgroundColor: "rgb(30, 101, 144)",
                    fontSize: "1.5em",
                    border: "0px solid black",
                    cursor: "pointer",
                    fontWeight: "bold",
                    width: "30px",
                    height: "30px",
                    lineHeight: "30px",
                    textAlign: "center",
                    margin: "5px",
                    marginBottom: "15px"
                  }}
                  onClick={() => {
                    this.props.addToBucket(product);
                  }}
                >
                  +
                </div>
                <div
                  style={{
                    borderRadius: "30px",
                    color: "#fff",
                    backgroundColor: "red",
                    fontSize: "1.5em",
                    border: "0px solid black",
                    cursor: "pointer",
                    fontWeight: "bold",
                    width: "30px",
                    height: "30px",
                    lineHeight: "30px",
                    textAlign: "center",
                    margin: "5px"
                  }}
                  onClick={() => {
                    this.props.removeFromBucket(product);
                  }}
                >
                  -
                </div>
              </div>
              <LazyLoadImage
                src={
                  product.photos && product.photos.length > 0
                    ? product.photos[0].url
                    : backupImage
                }
                style={{
                  height: "75px",
                  width: "75px",
                  minHeight: "75px",
                  minWidth: "75px",
                  borderRadius: "75px",
                  border: "0px solid gainsboro",
                  objectFill: "cover",
                  margin: "5px",
                  backgroundColor: "white",
                  objectFit: "contain"
                }}
                afterLoad={() => {
                  this.setState(prevState => {
                    return {
                      ...prevState,
                      [0]: true
                    };
                  });
                }}
                onError={() => {
                  let probElem = document.getElementById("img" + product.key);
                  if (probElem && probElem !== undefined) {
                    probElem.src = backupImage;
                  }
                }}
                id={"img" + product.key}
              />

              <div
                style={{
                  width: "100%",
                  display: "flex"
                }}
              >
                <table
                  className="table table-lg"
                  style={{
                    margin: "auto"
                  }}
                >
                  <tr>
                    <td>{product.productNameEnglish}</td>
                    <td>
                      <div
                        style={{
                          fontSize: "22px",
                          textAlign: "right",
                          margin: "3px"
                        }}
                      >
                        ${product.amount}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{product.unit}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      {product.quantity} x {product.productPrice}
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
            <div></div>
          </div>
        );
      });
    }
  };

  getActionButtons = rec => {
    return (
      <div
        style={{
          textAlign: "right",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end"
        }}
      >
        <span>
          <div
            style={{
              borderRadius: "30px",
              color: "#fff",
              backgroundColor: "red",
              fontSize: "1.5em",
              border: "0px solid black",
              cursor: "pointer",
              fontWeight: "bold",
              width: "30px",
              height: "30px",
              lineHeight: "30px",
              textAlign: "center",
              margin: "5px"
            }}
            onClick={() => {
              this.props.removeFromBucket(rec);
            }}
          >
            -
          </div>
        </span>

        <span>
          <div
            style={{
              borderRadius: "30px",
              color: "#fff",
              backgroundColor: "rgb(30, 101, 144)",
              fontSize: "1.5em",
              border: "0px solid black",
              cursor: "pointer",
              fontWeight: "bold",
              width: "30px",
              height: "30px",
              lineHeight: "30px",
              textAlign: "center",
              margin: "5px"
            }}
            onClick={() => {
              this.props.addToBucket(rec);
            }}
          >
            +
          </div>
        </span>
      </div>
    );
  };

  getPadItems = () => {
    return (
      <div
        style={{
          padding: "5px",
          fontSize: "12px"
        }}
      >
        {this.getItems()}
      </div>
    );
  };

  getFooter = () => {
    let currBucket = _.cloneDeep(this.props.db["bucket"]);
    //console.log("bug here : " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket[0].key !== undefined
    ) {
      let totAmt = currBucket.reduce((sum, item) => {
        sum = sum + parseFloat(item.amount.replace(/,/g, ""));
        return parseFloat(sum);
      }, 0);
      return (
        <div
          style={{
            textAlign: "center",
            position: "fixed",
            maxWidth: "800px",
            bottom: "0px",
            width: "100%",
            margin: "auto",
            textAlign: "center",
            backgroundColor: "white",
            padding: "0px",
            display: "flex",
            border: "1px solid grey",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)"
          }}
        >
          <div
            style={{
              borderRadius: "5px",
              color: "black",
              backgroundColor: "white",
              fontSize: "18px",
              cursor: "pointer",
              fontWeight: "bold",
              width: "50%",
              height: "40px",

              textAlign: "center",
              opacity: 1,

              margin: "5px"
            }}
          >
            <div>
              <span
                style={{ fontSize: "10px", magin: "3px", marginLeft: "10px" }}
              >
                Total:
              </span>
              {" $"}
              {numeral(totAmt).format("0,0.00")}
            </div>
            <div>
              <span style={{ fontSize: "10px", margin: "3px" }}>Items: </span>{" "}
              {currBucket.length}
            </div>
          </div>

          <div
            style={{
              padding: "0.6em 0.6em",
              borderRadius: "8px",
              color: "#fff",
              backgroundColor: "rgb(30, 101, 144)",
              fontSize: "1.1em",
              border: "0px",
              cursor: "pointer",
              margin: "5px",
              fontWeight: "bold",
              border: "1px solid white",
              width: "50%"
            }}
            onClick={() => {
              this.saveHandler();
            }}
          >
            <span>
              <icon
                className="fa fa-paper-plane blink"
                style={{ color: "white", margin: "5px" }}
              />
            </span>
            <span>PLACE ORDER</span>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div
        style={{
          marginTop: "40px"
        }}
      >
        {this.state.stage === "orderForm" && <div>{this.getFooter()}</div>}
        {this.state.stage === "orderForm" && this.getOrderForm()}
        {this.state.stage === "showConfirmation" && this.getOrderConformation()}

        {this.state.stage === "showUpdateConfirmation" &&
          this.getOrderUpdateConfirmation()}

        {this.state.stage === "showCancellation" && this.getOrderCancellation()}
        <div
          style={{
            height: "300px"
          }}
        ></div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail:
      state.db.currentUser && state.db.currentUser.userEmail
        ? state.db.currentUser.userEmail
        : "",
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userProfile: state.db.userProfile,
    selectedRecord: state.db["selected" + state.ui.tableName],
    db: state.db,
    createNewRec: state.ui.operationType === "add",
    operationType: state.ui.operationType,
    orders: state.db.deliveryRequest,
    users: state.db.users
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => dispatch(selectARecord(params)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers)),
    onAddArray: data => dispatch(actionAddArray2Redux(data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(OrderPadDirectSupplier);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/OrderPadDirectSupplier.jsx